// Public page header: carrier name on the left, CargoMinds attribution on the right.
export const TruckListHeader = ({ name }) => (
    <header className="w-full bg-cm-p-surface shadow-[0_4px_12px_rgba(0,0,0,0.06)]">
        <div className="mx-auto flex max-w-[1472px] items-center justify-between gap-4 px-4 py-6 sm:px-6">
            <h1 className="truncate text-[32px] font-semibold leading-none text-cm-p-text-primary">{name || " "}</h1>
            <p className="shrink-0 text-base text-cm-p-text-secondary">
                Powered by <span className="font-medium text-cm-p-text-primary">CargoMinds</span>
            </p>
        </div>
    </header>
);
